// Modified Availability Filter for Shopify Dawn Theme
document.addEventListener('DOMContentLoaded', function() {
  // Check if we're on a collection page
  if (isCollectionPage()) {
    // Check if any other filter is already applied in the URL
    if (hasOtherFiltersApplied()) {
      applyAvailabilityFilter();
    }
    
    // Set up observers to monitor filter selections
    setupObservers();
  }

  // Function to check if we're on a collection page
  function isCollectionPage() {
    // Check if URL contains /collections/ or if there are collection elements on the page
    return window.location.pathname.includes('/collections/') || 
           document.querySelector('.collection, .collection-grid, .collection__products') !== null;
  }
  
  // Function to check if any filters other than availability are applied
  function hasOtherFiltersApplied() {
    const currentUrl = new URL(window.location.href);
    const params = currentUrl.searchParams;
    
    // Check for any filter parameter except availability
    for (const [key, value] of params.entries()) {
      if (key.startsWith('filter.') && !key.includes('availability')) {
        return true;
      }
    }
    
    // Check for sort parameters
    if (params.has('sort_by')) {
      return true;
    }
    
    return false;
  }
  
  // Function to apply the availability filter
  function applyAvailabilityFilter() {
    // Add availability=1 parameter to URL if not already present
    const currentUrl = new URL(window.location.href);
    
    // Only add if it's not already in the URL
    if (!currentUrl.searchParams.has('filter.v.availability')) {
      currentUrl.searchParams.set('filter.v.availability', '1');
      
      // Use replaceState to avoid creating a new browser history entry
      window.history.replaceState({}, '', currentUrl.toString());
      console.log('Added availability filter to URL');
    }
    
    // Try to find and check the availability checkbox if it exists
    const availabilityCheckbox = document.querySelector('input[name="filter.v.availability"][value="1"], input[name="filter.v.availability"][value="true"]');
    if (availabilityCheckbox && !availabilityCheckbox.checked) {
      availabilityCheckbox.checked = true;
      availabilityCheckbox.dispatchEvent(new Event('change', { bubbles: true }));
    }
    
    // Hide the availability filter from view
    hideAvailabilityFilter();
  }
  
  // Function to hide the availability filter
  function hideAvailabilityFilter() {
    // Hide by multiple possible selectors based on Dawn theme structure
    // Apply CSS to hide these elements - use querySelectorAll because :has() selector might not work in all cases
    document.querySelectorAll('[data-filter*="availability"], [data-filter*="Available"]').forEach(el => {
      el.style.display = 'none';
    });
    
    // For Dawn theme specifically, look for details elements with summaries containing "availability"
    const filterDetails = document.querySelectorAll('details.filter-group');
    filterDetails.forEach(detail => {
      const summary = detail.querySelector('summary');
      if (summary && summary.textContent.toLowerCase().includes('availability')) {
        detail.style.display = 'none';
      }
    });
    
    // Hide active filter badges for availability
    document.querySelectorAll('.active-filters__button').forEach(button => {
      if (button.textContent.toLowerCase().includes('available') || 
          button.getAttribute('data-filter')?.includes('availability')) {
        button.style.display = 'none';
      }
    });
  }
  
  // Set up event listeners and observers for dynamic content
  function setupObservers() {
    // Listen for filter selection changes
    document.addEventListener('click', function(event) {
      // Check if the clicked element is a filter checkbox or button
      const isFilterElement = event.target.closest('input[type="checkbox"][name^="filter."], .facet-checkbox, .collection-filters__item');
      
      if (isFilterElement) {
        // If a filter was clicked, apply availability filter after a short delay to let the original click process
        setTimeout(function() {
          // Only apply if another filter was actually selected (not just clicked and unselected)
          if (hasOtherFiltersApplied()) {
            applyAvailabilityFilter();
          }
        }, 100);
      }
    });

    // Listen for URL changes (for browser back/forward navigation)
    window.addEventListener('popstate', function() {
      // Check if other filters are applied before applying availability filter
      if (hasOtherFiltersApplied()) {
        setTimeout(applyAvailabilityFilter, 100);
      }
    });
    
    // Add event listeners to all filter forms
    document.querySelectorAll('form.facets__form, form.filter-form').forEach(form => {
      form.addEventListener('submit', function(e) {
        // Only add availability parameter if the form has other filters selected
        let hasOtherFormFilters = false;
        
        // Check for selected checkboxes or inputs that aren't the availability filter
        form.querySelectorAll('input[type="checkbox"]:checked, select').forEach(input => {
          if (input.name && input.name.startsWith('filter.') && !input.name.includes('availability')) {
            hasOtherFormFilters = true;
          }
        });
        
        if (hasOtherFormFilters) {
          // Add availability parameter to form submission
          const formAction = new URL(form.action, window.location.origin);
          formAction.searchParams.set('filter.v.availability', '1');
          form.action = formAction.toString();
        }
      });
    });
    
    // Listen for AJAX requests (for Search & Filter app)
    const originalFetch = window.fetch;
    window.fetch = function(url, options) {
      // If this is a collection URL with other filters, add the availability filter
      if (typeof url === 'string' && url.includes('/collections/')) {
        const fetchUrl = new URL(url, window.location.origin);
        
        // Check if the URL has other filters
        let hasOtherFiltersInUrl = false;
        for (const [key, value] of fetchUrl.searchParams.entries()) {
          if (key.startsWith('filter.') && !key.includes('availability')) {
            hasOtherFiltersInUrl = true;
            break;
          }
        }
        
        if (hasOtherFiltersInUrl && !fetchUrl.searchParams.has('filter.v.availability')) {
          fetchUrl.searchParams.set('filter.v.availability', '1');
          url = fetchUrl.toString();
        }
      }
      return originalFetch.call(this, url, options);
    };
    
    // Create observer for facet/filter changes
    const facetsContainer = document.querySelector('.facets-container, .facets__wrapper, .collection-filters');
    if (facetsContainer) {
      const observer = new MutationObserver(function() {
        // Check if other filters are applied
        if (hasOtherFiltersApplied()) {
          setTimeout(applyAvailabilityFilter, 100);
        }
      });
      
      observer.observe(facetsContainer, {
        childList: true,
        subtree: true
      });
    }
  }
});